"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var filter_1 = require("./filter");
var filterTypes = Object.keys(filter_1.default).filter(function (i) { return i !== 'filter'; });
function getInteractionPropType(key) {
    var types = [PropTypes.bool, PropTypes.oneOf([key])], propType = PropTypes.oneOfType(types);
    propType['acceptsArray'] = PropTypes.oneOfType(types.concat(PropTypes.array));
    return propType;
}
exports.elementType = createChainableTypeChecker(function (props, propName, componentName) {
    if (typeof props[propName] !== 'function') {
        if (React.isValidElement(props[propName]))
            return new Error('Invalid prop `' + propName + '` specified in  `' + componentName + '`.' +
                ' Expected an Element `type`, not an actual Element');
        if (typeof props[propName] !== 'string')
            return new Error('Invalid prop `' + propName + '` specified in  `' + componentName + '`.' +
                ' Expected an Element `type` such as a tag name or return value of React.createClass(...)');
    }
    return null;
});
exports.disabled = getInteractionPropType('disabled');
exports.readOnly = getInteractionPropType('readOnly');
exports.accessor = PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
]);
exports.message = PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.string
]);
exports.filter = PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.bool,
    PropTypes.oneOf(filterTypes)
]);
function createChainableTypeChecker(validate) {
    function checkType(isRequired, props, propName, componentName) {
        var rest = [];
        for (var _i = 4; _i < arguments.length; _i++) {
            rest[_i - 4] = arguments[_i];
        }
        componentName = componentName || '<<anonymous>>';
        if (props[propName] == null) {
            if (isRequired) {
                return new Error('Required prop `' + propName + '` was not specified in  `' + componentName + '`.');
            }
        }
        else
            return validate.apply(void 0, [props, propName, componentName].concat(rest));
    }
    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-components/lib/util/custom-prop-types.js
// module id = 28
// module chunks = 0 1 2 3 4 5 6